<div class="container">
  <div class="row card">
    <div class="card-body col-md-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openLg(transcript)">
        View video transcript
      </button>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - Adding the Details</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6" style="height: 35vh">
    <p>
      Hey, welcome to step five where we get into the nitty-gritty. We are
      talking details. I'm Cindy, your life story writing expert. This class is
      on getting the facts straight and adding the right details to your story.
      I'll cover adding details—locations, dates, people—and selecting a
      category for your story.
    </p>
    <p>
      Details set really set great stories apart. They make the reading
      experience much more enjoyable to your friends and family and contribute
      to a much more engaging TSOLife account.
    </p>
    <p>
      For locations, specific locations such as 100 East Main Street, Bowling
      Green, Kentucky, USA, are better for the story and appear better on the
      TSOLife map view; however, if you're unsure about what to set as the
      location, know that the location can be broad such as just Bowling Green,
      Kentucky, United States of America. A date is also required for every
      story. You have the option to set a singular date such as May 1, 2002, or
      a date range such as May 1 through May 4.
    </p>
    <p>
      For each story, you also have the option to tag people. To add a person to
      your story, simply type their name. Click Add another person to add
      additional people. You will also&nbsp;choose one of the available
      categories to organize your story under.
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
